// libs
import styled from 'styled-components'
// icons
import VerginaSunIcon from 'src/icons/vergina-sun.svg'
import ObjectIconOrigin from 'src/icons/object.svg'
import PowerBiIconOrigin from 'src/icons/power-bi.svg'
import PrivacyIconOrigin from '@mui/icons-material/Lock'
import LocationIconOrigin from '@mui/icons-material/LocationOn'
import IntegrationIconOrigin from '@mui/icons-material/ElectricalServices'
import BusinessUnitsIconOrigin from 'src/icons/hierarchy.svg'
import SystemProcessesIconOrigin from '@mui/icons-material/Cached'
import BusinessActivityIconOrigin from 'src/icons/activity.svg'
import BusinessProcessesIconOrigin from 'src/icons/process.svg'
// themes
import { sidebarIconCSS } from 'themes/views/layouts'

export const LocationsIcon = styled(LocationIconOrigin)<any>`
  ${sidebarIconCSS}
`

export const BusinessUnitsIcon = styled(BusinessUnitsIconOrigin)`
  ${sidebarIconCSS}
`

export const BusinessProcessesIcon = styled(BusinessProcessesIconOrigin)`
  ${sidebarIconCSS}
`

export const BusinessActivityIcon = styled(BusinessActivityIconOrigin)`
  ${sidebarIconCSS}
`

export const ObjectIcon = styled(ObjectIconOrigin)`
  ${sidebarIconCSS}
`

export const SystemProcessesIcon = styled(SystemProcessesIconOrigin)<any>`
  ${sidebarIconCSS}
`

export const PowerBiIcon = styled(PowerBiIconOrigin)`
  ${sidebarIconCSS}
`

export const IntegrationIcon = styled(IntegrationIconOrigin)<any>`
  ${sidebarIconCSS}
`

export const PrivacyIcon = styled(PrivacyIconOrigin)<any>`
  ${sidebarIconCSS}
`

export const AiIcon = styled(VerginaSunIcon)<any>`
  ${sidebarIconCSS}
`
